// extracted by mini-css-extract-plugin
export default {"cls1":"PayeeViewComplianceSection-LockedOutLabel_cls1__nyC1c","cls2":"PayeeViewComplianceSection-LockedOutLabel_cls2__-M+X0 PayeeViewComplianceSection-LockedOutLabel_cls1__nyC1c"};